import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=e809aa06&scoped=true&"
import script from "./NotFoundView.vue?vue&type=script&lang=js&"
export * from "./NotFoundView.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=e809aa06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e809aa06",
  null
  
)

export default component.exports